<img src="assets/images/spinner.gif" alt="" *ngIf="loading" width="40">